module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUBAMAAABlm+CwAAAAIVBMVEUAAAAXFxcZGRkaGhoaGhoYGBgaGhoZGRkZGRkZGRkZGRnPLQJGAAAAC3RSTlMAIjNEd4iqu8zd7qCCaKcAAABrSURBVBjTY2BgEHFmAAITRyDBpOTZpgQEGVOUFBi0Vi3zWgUES7JWLWLQYvBsAynLmMIA5LhETnMBgsypLkBOGhyAlMEBQU4IEoe1AIkT5eLiDOdUpaWlwDnsAcgGlBBnD5yD7FAWFzhwAABdfCujpApvBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/date-from.png
// module id = 658
// module chunks = 0